const replaceSymbolsAsPerDmn = (value: string, dataType: string, fieldType: string): string | undefined => {
  if (dataType !== '' && dataType === 'double') {
    value = value.replace(/[" ]/g, '');
  }

  if (!value || value.trim() === '' || value.trim().toLowerCase() === 'null') {
    return `<text> </text>`;
  }

  // Handle 'not' separately
  if (value.includes('not')) {
    const remainingValues = value.replace(/not/g, '').trim();

    if (!remainingValues) {
      return undefined;
    }

    const parts = remainingValues.split(/\s+/);
    return `<text>not(${parts.join(' ')})</text>`;
  }

  // Remove `=` if it's alone with a number (not part of >=, <=, etc.)
  const trimmed = value.trim();
  const match = trimmed.match(/^=?\s*(-?\d+(\.\d+)?)$/); // matches '=10', '= 10', '10', '-10', '= -10', etc.
  if (match && !trimmed.startsWith('>=') && !trimmed.startsWith('<=') && !trimmed.startsWith('>') && !trimmed.startsWith('<')) {
    value = trimmed.replace(/^=\s*/, '');
  }

  let processedValue = value.trim();

  // If dataType is double, replace 'to' with '..'
  if (dataType === 'double') {
    processedValue = processedValue.replace(/to/g, '..');
  }

  processedValue = processedValue
    .replace(/>=/g, '&gt;=')
    .replace(/<=/g, '&lt;=')
    .replace(/>/g, '&gt;')
    .replace(/</g, '&lt;')
    .replace(/=/g, '=') // retain standalone '=' after all checks
    .replace(/""/g, '');

  if (fieldType === 'output' && dataType === 'string') {
    if(processedValue.includes('"')){
      processedValue = processedValue.replace(/"/g, '');
    }
    return `<text>"${processedValue}"</text>`;
  }

  return `<text>${processedValue}</text>`;


};

export default replaceSymbolsAsPerDmn;
